module.exports = __webpack_public_path__ + "static/Secure Privacy-2022c3cff5d7bab565f1d04e7c013975.jpg";